RivalIQ.apps.SocialPosts.module('curations', function (curations, App, Backbone, Marionette, $, _, s) {

    'use strict';

    function redactChannel(curation) {
        const redactedChannels = App.utils.getPostedUrlsRedactedChannels();
        const channel = RivalIQ.data.channels.get(curation.getProp('channel'));
        if (_.includes(redactedChannels, channel.get('channel'))) {
            return new RivalIQ.views.ItemView({
                template: '#postedUrlsChannelRedactedErrorTemplate',
                className: 'posted-urls-redacted-channel-error',
                model: new Backbone.Model({
                    channel: channel
                })
            });
        }
    }

    curations.PostedUrls = curations.SocialPosts.extend({
        title: 'Posted URLs',
        beforeFilters: [
            redactChannel
        ].concat(curations.SocialPosts.prototype.beforeFilters),
        widgetsView: curations.Layout.extend({
            getConfig: _.constant([
                {
                    name: 'links-shared-observations',
                    sizes: {
                        md: 12
                    },
                    page: 0
                },
                {
                    name: 'shared-urls-by-company',
                    sizes: {
                        md: 12
                    },
                    page: 0
                },
                {
                    name: 'links-posted-owned-vs-curated',
                    sizes: {
                        md: 12
                    },
                    page: 0
                },
                {
                    name: 'shared-domains',
                    sizes: {
                        md: 12
                    },
                    page: 1
                },
                {
                    name: 'links-posted',
                    sizes: {
                        md: 12
                    },
                    page: 1
                }
            ])
        }),
        getCurationId: function () {
            const me = this;
            return s.dasherize(me.id.toLowerCase());
        },

        getDataMetric: function () {
            return new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id
            });
        }
    });

}, window.s);
